var map = {
	"./Vrindavani Publicity Still 1.jpg": 143,
	"./Vrindavani Publicity Still 2.jpg": 5808,
	"./Vrindavani Publicity Still 5.jpg": 3811,
	"./Vrindavani Publicity Still 6.jpg": 9332,
	"./Vrindavani Publicity Still 7.jpg": 6705,
	"./Vrindavani Publicity Still 8.jpg": 4650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1323;